import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import baseUrl from "../../../api/universalApi";
import { useNavigate } from "react-router-dom";
import GenerateInvoice from "../../../components_payment/Invoice/GenerateInvoice"; // Adjust the path as needed

const Contract = () => {
  const user = useSelector((state) => state.auth?.authData?.user);
  const [contracts, setContracts] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [popup, setPopup] = useState(false);
  const [activeCampaign, setActiveCampaign] = useState(null);
  const [agreementData, setAgreementData] = useState(null);
  const navigate = useNavigate();

  const fetchContractDetails = async (email) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/agreement/getContractByEmail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch contract details");
      }
      const data = await response.json();
      setContracts(data);
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
  };

  const fetchInvoiceDetails = async (email) => {
    try {
      const response = await fetch(`${baseUrl}/api/agreement/getInvoices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch contract details");
      }
      const data = await response.json();
      setInvoice(data.invoices);
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
  };

  useEffect(() => {
    if (user?.email) {
      fetchContractDetails(user?.email);
      fetchInvoiceDetails(user?.email);
    }
  }, [user?.email]);

  const OpenInvoice = async (campaign_id) => {
    try {
      const response = await fetch(`${baseUrl}/api/invoice/openedInvoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ campaign_id: campaign_id }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch contract details");
      }
      const data = await response.json();
      fetchInvoiceDetails(user?.email);
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
  };

  const handleApproveInvoice = async (campaign_id, status) => {
    
    try {
      const response = await fetch(`${baseUrl}/api/invoice/approveInvoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ campaign_id: campaign_id, status: status }),
      });

      if (!response.ok) {
        throw new Error("Failed to approve invoice");
      }
      const data = await response.json();
      fetchInvoiceDetails(user?.email);
    } catch (error) {
      console.error("Error approving invoice:", error);
    }
  };

  const handleSendToFinance = async (invoice) => {
    try {
      const response = await fetch(
        `${baseUrl}/api/invoice/sendInvoiceToFinance`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            campaign_id: invoice.campaign_id,
            contract_id: invoice.contract._id,
            amount: invoice.amount,
            company: invoice.contract.company,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send invoice to finance");
      }
      const data = await response.json();
      console.log("Invoice sent to finance successfully:", data);
      alert("Invoice sent to Finance successfully");
       fetchInvoiceDetails(user?.email);
    } catch (error) {
      console.error("Error sending invoice to finance:", error);
    }
  };

  const handleProcessed = async (invoice) => {
    try {
      const response = await fetch(`${baseUrl}/api/invoice/markAsProcessed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          campaign_id: invoice.campaign_id,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send invoice to finance");
      }
      const data = await response.json();
      console.log("Invoice sent to finance successfully:", data);
      alert("Invoice sent to Finance successfully");
       fetchInvoiceDetails(user?.email);
    } catch (error) {
      console.error("Error sending invoice to finance:", error);
    }
  };
  return (
    <>
      <div>
        <h2>Contracts</h2>
      </div>
      <div className="flex flex-wrap gap-4">
        {contracts.map((contract, idx) => (
          <div
            key={contract._id || idx}
            className="border border-gray-300 rounded-lg p-4 min-w-[220px] bg-white shadow-md"
            onClick={() =>
              navigate(`/signContract/${contract?.campaign_id?._id}`)
            }
          >
            <h3 className="mb-2 text-lg font-semibold">
              {contract.company || "No Company"}
            </h3>
          </div>
        ))}
      </div>

      <div className="mt-4">
        <h2>Invoices</h2>
      </div>

     <div className="overflow-auto w-full">
  <table className="min-w-[1000px] table-auto border-collapse w-full text-sm">
    <thead>
      <tr className="bg-gray-100 text-left">
        <th className="p-2 border">Company</th>
        <th className="p-2 border">View</th>
        <th className="p-2 border">Status</th>
        <th className="p-2 border">Approve</th>
        <th className="p-2 border">Send to Finance</th>
        <th className="p-2 border">Processed</th>
      </tr>
    </thead>
    <tbody>
      {invoice.map((inv, idx) => (
        <tr key={inv._id || idx} className="border-b">
          <td className="p-2 border">{inv.contract.company || "No Company"}</td>

          <td className="p-2 border">
            {(inv?.status === "Opened" || inv?.status === "approved") ? (
              <button
                className="bg-green-300 rounded py-1 px-3"
                onClick={() => {
                  setActiveCampaign(inv?.campaignData);
                  setAgreementData(inv?.contract);
                  setPopup(true);
                }}
              >
                View Invoice
              </button>
            ) : (
              <button
                className="bg-gray-300 rounded py-1 px-3"
                onClick={() => OpenInvoice(inv?.campaign_id)}
              >
                Open Invoice
              </button>
            )}
          </td>

          <td className="p-2 border">
            {(inv?.status === "Opened" || inv?.status === "approved") ? (
              <span className="text-green-500">Invoice Opened</span>
            ) : (
              <span className="text-red-500">Invoice Not Opened</span>
            )}
          </td>

          <td className="p-2 border">
            {(inv?.status === "Opened" || inv?.status === "approved") ? (
              <button
                className="bg-green-300 rounded py-1 px-3"
                onClick={() => {
                  inv?.status === "approved"
                    ? alert("Invoice already approved")
                    : handleApproveInvoice(inv.campaign_id, "approved");
                }}
              >
                {inv?.status === "approved"
                  ? "Already Approved"
                  : "Approve Invoice"}
              </button>
            ) : (
              "--"
            )}
          </td>

          <td className="p-2 border">
            {inv?.status === "approved" ? (
              <button
                className="bg-blue-300 rounded py-1 px-3"
                onClick={() => {
                  inv?.sent_to_finance
                    ? alert("Invoice already sent to Finance")
                    : handleSendToFinance(inv);
                }}
              >
                {inv?.sent_to_finance
                  ? "Already Sent"
                  : "Send to Finance"}
              </button>
            ) : (
              "--"
            )}
          </td>

          <td className="p-2 border">
            {inv?.sent_to_finance ? (
              <button
                className="bg-yellow-300 rounded py-1 px-3"
                onClick={() => {
                  inv?.processed
                    ? alert("Invoice already processed")
                    : handleProcessed(inv);
                }}
              >
                {inv?.processed ? "Processed" : "Mark as Processed"}
              </button>
            ) : (
              "--"
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


      {popup && activeCampaign && agreementData && (
        <div className="fixed inset-0 z-50 flex items-center justify-center  bg-opacity-30 overflow-auto h-screen">
          <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-6 relative">
            <button
              onClick={() => setPopup(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-xl font-bold"
            >
              &times;
            </button>
            <GenerateInvoice
              campaignData={activeCampaign}
              contract={agreementData}
              setPopup={setPopup}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Contract;
